import React from 'react';
import { StepCheckImagerSync, PanelCheckImagerSync } from '.';
import notificationEnum from '../../../enums/notificationEnum';
import { useSelector } from 'react-redux';
import columbiaModeEnum from '../../../enums/columbiaModeEnum';

export default function NotificationManager() {
  const { mode } = useSelector((state) => state.columbia);

  return (
    mode === columbiaModeEnum.INTERACTIVE && (
      <div id="notification-sync-group">
        <StepCheckImagerSync notification={notificationEnum.CHECK_IMAGER_SYNC.STEP} />
        <PanelCheckImagerSync />
      </div>
    )
  );
}
